import {
  cn,
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@workspace/frontend-ui";

const AUTH_CODE_LENGTH = 6;
const AUTH_CODE_SLOT_INDEXES = [0, 1, 2, 3, 4, 5] as const;
const DIGITS_PATTERN = "^\\d+$";

type Props = {
  onChange?: (value: string) => void;
  onSubmit?: (value: string) => void;
  errorMessage?: string;
  "data-testid"?: string;
};

const AuthCodeOtpInput: FC<Props> = ({
  onChange,
  onSubmit,
  errorMessage,
  "data-testid": testId = "auth-code",
}) => (
  <InputOTP
    maxLength={AUTH_CODE_LENGTH}
    pattern={DIGITS_PATTERN}
    inputMode="numeric"
    onChange={onChange}
    onComplete={onSubmit}
    data-testid={testId}
    containerClassName="flex w-full justify-center"
  >
    <InputOTPGroup
      className={cn(
        "gap-2 rounded-none ring-0 relative",
        errorMessage && "pb-6",
      )}
    >
      {AUTH_CODE_SLOT_INDEXES.map((slotIndex) => (
        <InputOTPSlot
          key={`auth-code-slot-${slotIndex}`}
          index={slotIndex}
          aria-invalid={!!errorMessage}
          className="border border-border bg-background text-2xl data-[active=true]:border-ring data-[active=true]:border-2! data-[active=true]:ring-0 aria-invalid:border-2! aria-invalid:border-destructive w-11.5 h-14 rounded-xl"
        />
      ))}

      {!!errorMessage && (
        <div
          data-testid={`${testId}-error`}
          className="absolute bottom-0 left-0 flex items-center justify-start p-1.25 text-xs text-destructive"
        >
          {errorMessage}
        </div>
      )}
    </InputOTPGroup>
  </InputOTP>
);

export default AuthCodeOtpInput;
